import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/birthdate'));

export default function (dependencies) {
  const { language } = dependencies;

  const config = {
    extraState: {
      localState: {
        day: '',
        month: '',
        year: '',
      },
    },
  };

  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    config,
    validators: [
      function checkDate(state) {
        return dateValidationErrors(state.localState);
      },
      function checkIfAllFilledIn(state) {
        return allFilledIn(state.localState);
      },
    ],
  };

  function checkMonthNumbers(month) {
    return Number(month) < 13 && Number(month) > 0;
  }

  function checkDateNumbers(month, date) {
    switch (Number(month)) {
      case 1:
        return Number(date) < 32;
      case 2:
        return Number(date) < 30;
      case 3:
        return Number(date) < 32;
      case 4:
        return Number(date) < 31;
      case 5:
        return Number(date) < 32;
      case 6:
        return Number(date) < 31;
      case 7:
        return Number(date) < 32;
      case 8:
        return Number(date) < 32;
      case 9:
        return Number(date) < 31;
      case 10:
        return Number(date) < 32;
      case 11:
        return Number(date) < 31;
      case 12:
        return Number(date) < 32;
      default:
        return false;
    }
  }

  function checkYearNumbers(year) {
    const currentYear = new Date().getFullYear();
    const tooOldYear = Number(year) < currentYear - 150;
    const tooNewYear = Number(year) > currentYear;
    const tooLongYearString = year.length !== 4;
    const invalidYear = tooOldYear || tooNewYear || tooLongYearString;

    if (invalidYear) return false;
    else return true;
  }

  function validateDate(localState) {
    const { day, month, year } = localState;

    let validDay = true;
    let validMonth = true;
    let validYear = true;

    if (day) validDay = day < 32 && day > 0;
    if (month) validMonth = checkMonthNumbers(month);
    if (year) validYear = checkYearNumbers(year);

    return {
      invalidDay: !validDay,
      invalidMonth: !validMonth,
      invalidYear: !validYear,
      invalidDayInMonth: month ? !checkDateNumbers(month, day) : false,
    };
  }

  function dateValidationErrors(localState) {
    const { invalidDay, invalidDayInMonth, invalidMonth, invalidYear } = validateDate(localState);

    const moreThanOneFilledIn = (invalidDay && invalidMonth) || (invalidMonth && invalidYear) || (invalidDay && invalidYear);

    if (moreThanOneFilledIn) return language['date-invalid'];

    if (invalidMonth) return language.invalid_month;
    else if (invalidDayInMonth) return language.invalid_day_in_month;
    else if (invalidDay) return language.invalid_day;
    else if (invalidYear) return language.invalid_year;
    else return false;
  }

  function allFilledIn(localState) {
    const { day, month, year } = localState;

    const moreThanOneMissing = (!day && !month) || (!month && !year) || (!day && !year);

    const allFilledIn = day && month && year;

    if (allFilledIn) return false;
    else if (moreThanOneMissing || !day) return language.missing_date;
    else if (!month) return language.missing_month;
    else if (!year) return language.missing_year;
    else return;
  }
}
